import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        // collections of global snackbars
        snackbars: [],
        // flag to keep track of if we are currently logging out or not
        isLogginggOut: false,
        // Flag to keep track of if we are currently loading
        isLoading: false,
        // Current number of concurent requests
        currentNumberOfRequests: 0,
        // Access Token for authentification
        accessToken: null,
        // Token expires in for authentification
        tokenExpiresIn: null,
        // Refresh token for authentification
        refreshToken: null
    },
    getters: {
        // get the info of if we are currently logging out
        getIsLoggingOut(state) {
            return state.isLogginggOut;
        },
        // Get the accessToken
        getAccessToken(state) {
            var storeValue = localStorage.getItem('accessToken');
            // if the localstorage is empty and not the vuex store, we wanna override the store (debugging use case)
            if (state.accessToken != storeValue || !storeValue) {
                return storeValue;
            }
            else {
                return state.accessToken;
            }
        },
        // Get token expires in
        getTokenExpiresIn(state) {
            var storeValue = localStorage.getItem('tokenExpiresIn');
            // if the localstorage is empty and not the vuex store, we wanna override the store (debugging use case)
            if (state.tokenExpiresIn != storeValue || !storeValue) {
                return storeValue;
            }
            else {
                return state.tokenExpiresIn;
            }
        },
        // Get refresh token
        getRefreshToken(state) {
            var storeValue = localStorage.getItem('refreshToken');
            // if the localstorage is empty and not the vuex store, we wanna override the store (debugging use case)
            if (state.refreshToken != storeValue || !storeValue) {
                return storeValue;
            }
            else {
                return state.refreshToken;
            }
        }
    },
    mutations: {
        // set the info of if we are currently logging out
        SET_ISLOGGINGOUT(state, isLogginggOut) {
            state.isLogginggOut = isLogginggOut;
        },
        // add a new snackbar in the collection, based on its status (status define what type of message it should display)
        SET_SNACKBAR(state, snackbar) {
            var shouldCommit = false;
            // Get the type of the snackbar
            var snackbarStatus = snackbar.status;
            // If the snackbar should prevent duplicates flag is true
            if (snackbar.shouldPreventDuplicates) {
                // We wanna wait 10 seconds before registering new snackbar of the same status
                var allCurrentStatusSnackbars = state.snackbars.filter(s => s.status === snackbarStatus);
                // if there are already several session_timeout snackbars
                if (allCurrentStatusSnackbars.length > 0) {
                    // Take the latest
                    var latest = allCurrentStatusSnackbars[allCurrentStatusSnackbars.length - 1];
                    // If the latest has been created more than 10 seconds ago, we can add it to the state
                    var latestPlusXSecTimestamp = latest.timestamp.setSeconds(latest.timestamp.getSeconds() + snackbar.blockNextForInSec);
                    // If the new snackbar is more than 10 seconds after the previous one
                    if (snackbar.timestamp.getTime() >= latestPlusXSecTimestamp) {
                        shouldCommit = true;
                    }
                }
                else {
                    shouldCommit = true;
                }
            }
            else {
                shouldCommit = true;
            }

            // If the shouldCommit flag is true we can commit (if it is not, this is because we wanna prevent several same snackbar to be displayed next to each other)
            if (shouldCommit) {
                state.snackbars = state.snackbars.concat(snackbar);
            }
        },
        // Add one to the current number of requests
        ADD_REMOVE_REQUEST(state, toAdd) {
            // if we wanna add a request
            if (toAdd === true) {
                state.currentNumberOfRequests++;
            }
            else {
                state.currentNumberOfRequests--;
            }

            // If there is one or more pending requests, we wanna set isLoading to true
            if (state.currentNumberOfRequests > 0) {
                state.isLoading = true;
            }
            else {
                state.isLoading = false;
            }
        },
        // Reset the current number of request to zero
        RESET_CURRENT_NBR_REQUESTS(state) {
            state.currentNumberOfRequests = 0;
            state.isLoading = false;
        },
        // Update the accessToken for authentification
        UPDATE_ACCESS_TOKEN(state, accessToken) {
            state.accessToken = accessToken;
        },
        // Update the token expires in
        UPDATE_TOKEN_EXPIRES_IN(state, expiresIn) {
            state.tokenExpiresIn = expiresIn;
        },
        // Update refresh token
        UPDATE_REFRESH_TOKEN(state, refreshToken) {
            state.refreshToken = refreshToken;
        }
    },
    actions: {
        // build the snackbar object to be committed
        setSnackbar({ commit }, snackbar) {
            // status is the type of the snackbar
            snackbar.status = snackbar.status || 'success';
            snackbar.showing = true;
            snackbar.timeout = snackbar.timeout || 2000;

            switch (snackbar.status) {
                case 'success':
                    snackbar.color = snackbar.color || 'success';
                    snackbar.title = snackbar.title || "Succès :";
                    snackbar.icon = snackbar.icon || "check";
                    snackbar.shouldPreventDuplicates = snackbar.shouldPreventDuplicates || false;
                    snackbar.centered = snackbar.centered || false;
                    break;
                case 'error':
                    snackbar.color = snackbar.color || 'error';
                    snackbar.title = snackbar.title || "Erreur :";
                    snackbar.icon = snackbar.icon || "error";
                    snackbar.shouldPreventDuplicates = snackbar.shouldPreventDuplicates || false;
                    snackbar.centered = snackbar.centered || false;
                    break;
                case 'warning':
                    snackbar.color = snackbar.color || 'warning';
                    snackbar.title = snackbar.title || "Attention :";
                    snackbar.icon = snackbar.icon || "warning";
                    snackbar.shouldPreventDuplicates = snackbar.shouldPreventDuplicates || false;
                    snackbar.centered = snackbar.centered || false;
                    break;
                case 'information':
                    snackbar.color = snackbar.color || 'info';
                    snackbar.title = snackbar.title || "Info :";
                    snackbar.icon = snackbar.icon || "info";
                    snackbar.shouldPreventDuplicates = snackbar.shouldPreventDuplicates || false;
                    snackbar.centered = snackbar.centered || false;
                    break;
                // loggin welcome message
                case 'welcome_message':
                    snackbar.color = snackbar.color || 'success';
                    snackbar.title = snackbar.title || "Authentifié";
                    // username only relevant for this snackbar
                    snackbar.username = snackbar.username || "Inconnu";
                    snackbar.text = snackbar.text || "Bienvenue " + snackbar.username;
                    snackbar.icon = snackbar.icon || "check";
                    snackbar.timeout = snackbar.timeout || 2000;
                    snackbar.blockNextForInSec = snackbar.timeout / 1000;
                    snackbar.timestamp = new Date();
                    snackbar.shouldPreventDuplicates = snackbar.shouldPreventDuplicates || true;
                    snackbar.centered = snackbar.centered || false;
                    break;
                // session timeout message
                case 'session_timeout':
                    snackbar.color = snackbar.color || 'error';
                    snackbar.title = snackbar.title || "Session expirée";
                    snackbar.text = snackbar.text || "Merci de vous reconnecter";
                    snackbar.icon = snackbar.icon || "error";
                    snackbar.timeout = snackbar.timeout || 2000;
                    snackbar.blockNextForInSec = snackbar.timeout / 1000;
                    snackbar.timestamp = new Date();
                    snackbar.shouldPreventDuplicates = snackbar.shouldPreventDuplicates || true;
                    snackbar.centered = snackbar.centered || false;
                    break;
                // session will soon expire message
                case 'session_timeout_in_less_than_X_minutes':
                    snackbar.color = snackbar.color || 'warning';
                    snackbar.title = snackbar.title || "Session sur le point d'expirer";
                    // minutes only relevant for this snackbar
                    snackbar.minutes = snackbar.minutes || "Inconnu";
                    snackbar.text = snackbar.text || "Votre session va expirer dans moins de " + snackbar.minutes + " minute" + (Number.parseInt(snackbar.minutes, 10) > 1 ? "s." : ".");
                    snackbar.icon = snackbar.icon || "warning";
                    snackbar.timeout = snackbar.timeout || 2000;
                    snackbar.blockNextForInSec = 60 * 5;
                    snackbar.timestamp = new Date();
                    snackbar.shouldPreventDuplicates = snackbar.shouldPreventDuplicates || true;
                    snackbar.centered = snackbar.centered || false;
                    break;
                // user is logged out message
                case 'user_loggedout':
                    snackbar.color = snackbar.color || 'info';
                    snackbar.title = snackbar.title || "Déconnexion réussie";
                    snackbar.text = snackbar.text || "Votre session a bien été terminée.";
                    snackbar.icon = snackbar.icon || "info";
                    snackbar.timeout = snackbar.timeout || 2000;
                    snackbar.blockNextForInSec = snackbar.timeout / 1000;
                    snackbar.timestamp = new Date();
                    snackbar.shouldPreventDuplicates = snackbar.shouldPreventDuplicates || true;
                    snackbar.centered = snackbar.centered || false;
                    break;
                // got the HTTP 401 response from backend message
                case '401_unauthorized':
                    snackbar.color = snackbar.color || 'error';
                    snackbar.title = snackbar.title || "401 : Unauthorized";
                    snackbar.text = snackbar.text || "Vous n'êtes pas autorisé à accéder à cette ressource.";
                    snackbar.icon = snackbar.icon || "error";
                    snackbar.timeout = snackbar.timeout || 2000;
                    snackbar.blockNextForInSec = snackbar.timeout / 1000;
                    snackbar.timestamp = new Date();
                    snackbar.shouldPreventDuplicates = snackbar.shouldPreventDuplicates || true;
                    snackbar.centered = snackbar.centered || false;
                    break;
                default:
                    snackbar.color = snackbar.color || 'success';
                    snackbar.title = snackbar.title || "Succès :";
                    snackbar.icon = snackbar.icon || "success";
                    snackbar.shouldPreventDuplicates = snackbar.shouldPreventDuplicates || false;
                    snackbar.centered = snackbar.centered || false;
                    break;
            };

            commit('SET_SNACKBAR', snackbar);
        },
        // set the logging out flag
        setIsLoggingOut({ commit }, isLogginggOut) {
            commit('SET_ISLOGGINGOUT', isLogginggOut);
        },
        // Add one to the current number of requests
        addRemoveRequest({ commit }, toAdd) {
            commit('ADD_REMOVE_REQUEST', toAdd);
        },
        // Reset the current number of request to zero
        resetCurrentNumberOfRequests({ commit }) {
            commit('RESET_CURRENT_NBR_REQUESTS');
        },
        // Save the accessToken in local storage and in store
        saveAccessToken({ commit }, accessToken) {
            // If there is a token
            if (accessToken) {
                // Save the token in local storage
                localStorage.setItem('accessToken', accessToken);
            }
            else {
                // Delete from localstorage
                localStorage.removeItem('accessToken');
            }

            // Save the token in the store
            commit('UPDATE_ACCESS_TOKEN', accessToken);
        },
        // Get the accessToken from local storage and save it in store (used when app refresh)
        fetchAccessToken({ commit }) {
            commit('UPDATE_ACCESS_TOKEN', localStorage.getItem('accessToken'));
        },
        // Save the token expires in, in local storage and in store
        saveTokenExpiresIn({ commit }, expiresIn) {
            // If there is a token
            if (expiresIn) {
                // Save the token in local storage
                localStorage.setItem('tokenExpiresIn', expiresIn);
            }
            else {
                // Delete from localstorage
                localStorage.removeItem('tokenExpiresIn');
            }

            // Save the token expires in, in the store
            commit('UPDATE_TOKEN_EXPIRES_IN', expiresIn);
        },
        // Get the expires in, from local storage and save it in store (used when app refresh)
        fetchTokenExpiresIn({ commit }) {
            commit('UPDATE_TOKEN_EXPIRES_IN', localStorage.getItem('tokenExpiresIn'));
        },
        // Save the refresh token, in local storage and in store
        saveRefreshToken({ commit }, refreshToken) {
            // If there is a token
            if (refreshToken) {
                // Save the token in local storage
                localStorage.setItem('refreshToken', refreshToken);
            }
            else {
                // Delete from localstorage
                localStorage.removeItem('refreshToken');
            }
            // Save the refresh token, in the store
            commit('UPDATE_REFRESH_TOKEN', refreshToken);
        },
        // Get the refresh token, from local storage and save it in store (used when app refresh)
        fetchRefreshToken({ commit }) {
            commit('UPDATE_REFRESH_TOKEN', localStorage.getItem('refreshToken'));
        }
    }
});